import React, { useEffect } from 'react';
import { MessageSquare } from 'lucide-react';
import Container from '@/components/ui/Container';
import DashboardHeader from '@/components/dashboard/DashboardHeader';
import FlatDashboardCard from '@/components/ui/FlatDashboardCard';
import AssistantSelection from '@/components/ai-agents/AssistantSelection';
import { useLocalStorageState } from '@/hooks/ai-agents/useLocalStorageState';

const AIAgentSettings = () => {
  const { setActiveTab } = useLocalStorageState();

  // On page load/refresh, switch to threads mode for consistency
  useEffect(() => {
    const initializeThreadsView = async () => {
      // Small delay to ensure components are mounted
      await new Promise(resolve => setTimeout(resolve, 100));
      
      // Switch to threads tab for consistency
      setActiveTab('threads');
      
      console.log('AI Agents page loaded - defaulted to threads section');
    };

    initializeThreadsView();
  }, [setActiveTab]); // Only run once on mount

  return <Container>
      <DashboardHeader title="AI Agents" description="Start a new conversation or manage your chat history." icon={<MessageSquare size={24} strokeWidth={2} />} hideOnMobile={false} />
      
      <div className="grid grid-cols-1 gap-6">
        <FlatDashboardCard>
          <div className="space-y-6">
            <div className="text-center space-y-2">
              <h2 className="text-2xl font-medium">Meet Your Agents</h2>
              <p className="text-sm text-muted-foreground">
                Select an AI assistant personality to help you with your tasks
              </p>
            </div>
            <AssistantSelection />
          </div>
        </FlatDashboardCard>
      </div>
    </Container>;
};

export default AIAgentSettings; 